
<template>
  <a-modal
    title="开始预估"
    :visible="visible.estimated"
    :bodyStyle="{ padding: '10px' }"
    @ok="ok"
    @cancel="cancel"
    :maskClosable="false"
    :forceRender="true"
    :destroyOnClose="true"
    width="800px"
    okText="开始预估"
    cancelText="取消"
  >
    <a-form :form="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item label="配方适用的动物类型">
        <span style="font-size: 12px;">{{detail.animalTypeName}}</span>
        <p class="grayText">动物类型 将决定预估生长性能的计算模型，请确认当前配方的动物类型是否正确</p>
      </a-form-item>
      <a-form-item label="配方适用的体重阶段" v-if="growing">
        <p>{{startWeight}} - {{endWeight}}kg</p>
        <a-slider
          v-decorator="['weightArr',{rules: [{ required: true, message: '请选择配方适用的体重阶段' }]}]"
          range
          :max="max"
          :min="min"
          :marks="marks"
          :step="null"
          @change="change"
        />
        <p class="grayText">体重阶段 将影响生长性能、营养需要量和经济效益的计算结果，请选择合适的体重阶段</p>
      </a-form-item>
      <a-form-item label="配方适用的平均体重" v-if="weaned">
        <a-radio-group
          v-decorator="['averageWeight',{rules: [{ required: true, message: '请选择配方适用的平均体重' }]}]"
          :options="weightOptions"
        />
        <p class="grayText">平均体重 将影响生长性能、营养需要量的计算结果，请选择合适的体重</p>
      </a-form-item>
      <a-form-item label="配方适用的日期阶段" v-if="gestation">
        <a-slider
          v-decorator="['day']"
          range
          style="display: none;"
          disabled
          :max="114"
        />
        <span style="font-size: 12px;">1-114天</span>
        <p class="grayText">妊娠天数默认为114天，暂不支持修改</p>
      </a-form-item>
      <div v-if="sucklingow">
        <a-form-item label="哺乳母猪日期" style="display: none;">
          <a-slider
            v-decorator="['day']"
            range
            disabled
            :max="114"
          />
        </a-form-item>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { getRequest } from "@/components/Common/Utils/Utils";
import { nhfMixins } from "../../untils";

export default {
  mixins: [nhfMixins],
  data(){
    return {
      form: this.$form.createForm(this),
      predictionTypeName: '',
      predictionTypeCode: '',
      labelCol: { style: { width: '150px' } },
      wrapperCol: { style: { width: '600px' } },
      max: 140,
      min: 25,
      marks: {
        25:{
          label: '25KG'
        },
        50:{
          label: '50KG'
        },
        75:{
          label: '75KG'
        },
        100:{
          label: '100KG'
        },
        140:{
          label: '140KG'
        }
      },
      weightOptions: [
        { label: '5KG', value: '5' },
        { label: '10KG', value: '10' },
        { label: '15KG', value: '15' },
        { label: '20KG', value: '20' },
      ],
      startWeight: 0,
      endWeight: 0
    }
  },
  computed:{
    growing(){
      return this.predictionTypeCode === "growingFinishing";
    },
    weaned(){
      return this.predictionTypeCode === "startingPigs";
    },
    gestation(){
      return this.predictionTypeCode === "gestatingSows";
    },
    sucklingow(){
      return this.predictionTypeCode === "lactatingSows";
    },
    
  },
  watch:{
    'visible.estimated': {
      handler(val){
        if(val){
          let {animalTypeCode} = this.detail || {}
          if(animalTypeCode) this.$get(`/sat-maximization/predictiontype/predictionTypeByAnimalTypeId?animalTypeId=${animalTypeCode}`).then(res => {
            let {success,data} = res || {}
            if(success) {
              let {predictionTypeName,predictionTypeCode} = data || {}
              this.predictionTypeName = predictionTypeName
              this.predictionTypeCode = predictionTypeCode
              setTimeout(() => {
                this.change([25,50])
                let day = [1,114]
                if(this.predictionTypeCode === "lactatingSows") day = [1,21]
                this.form.setFieldsValue({weightArr: [25,50],averageWeight: '10',day})
              }, 0);
            }
          })
        }
      }
    },
  },
  methods:{
    ok(){
      // this.toggleVisible('estimated');
      this.form.validateFields((err,params) => {
        // this.setState({nhfEstimateData})
        setTimeout(() => {
          params.predictionTypeCode = this.predictionTypeCode
          let route =this.$router.resolve({path:`/sat/estimated-record/add?id=${getRequest('id')}&params=${JSON.stringify(params)}`,})
          window.open(route.href,"_blank")
        }, 0);
      })
    },
    cancel(){
      this.toggleVisible('estimated');
    },
    change(val){
      let [startWeight,endWeight] = val || []
      this.startWeight = startWeight,
      this.endWeight = endWeight
    }
  }
}
</script>
<style scoped>
.grayText{
  color: #999;
  line-height: 14px;
  font-size: 12px;
}
</style>